import { render, staticRenderFns } from "./CollapsableListItem.vue?vue&type=template&id=38cfc68f"
import script from "./CollapsableListItem.vue?vue&type=script&lang=js"
export * from "./CollapsableListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports